import { applicationContactsApi, loanContactsApi } from 'app/services/api';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LOAN_CONTACTS_ACTION_TYPE = createNamedActions(
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/loan-contacts`,
  {
    GET_LOAN_CONTACTS: 'GET_LOAN_CONTACTS',
    GET_LOAN_CONTACTS_VIEW: 'GET_LOAN_CONTACTS_VIEW',
    BULK_UPDATE_CONTACTS: 'BULK_UPDATE_CONTACTS',
  },
);

export const getLoanContactsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await loanContactsApi.getLoanContacts(params);

  return dispatch({
    type: LOAN_CONTACTS_ACTION_TYPE.GET_LOAN_CONTACTS,
    payload: data,
  });
});

export const getLoanContactsViewAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await loanContactsApi.getLoanContactsView(params);

  return dispatch({
    type: LOAN_CONTACTS_ACTION_TYPE.GET_LOAN_CONTACTS_VIEW,
    payload: data,
  });
});

export const bulkUpdateLoanContactsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await applicationContactsApi.bulkUpdate(params);

  return dispatch({
    type: LOAN_CONTACTS_ACTION_TYPE.BULK_UPDATE_CONTACTS,
    payload: data,
  });
});
